import {
  Button,
  DropdownMenu,
  Flex,
  IconButton,
  Skeleton,
  Tooltip,
} from "@radix-ui/themes";
import {
  ExitIcon,
  LayersIcon,
  MoonIcon,
  PersonIcon,
  SunIcon,
} from "@radix-ui/react-icons";

import { useAppDispatch } from "@/app/appStore";
import { logout } from "@/entities/session";
import { Preferences } from "@/pages/index/components/preferences";
import { appSession } from "@/shared/lib/storage";
import { useAuthRedirect } from "@/shared/hooks/useAuthRedirect";
import { useState } from "react";
import { useStaffMeQuery } from "@/shared/api";
import { useTheme } from "next-themes";
import { Link, useParams } from "react-router-dom";

export function TopBar() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const { redirectToLoginAfterLogout } = useAuthRedirect();
  const { data: staffMe, isLoading } = useStaffMeQuery();
  const { theme, setTheme } = useTheme();
  const { storeKey } = useParams();

  const handleLogout = () => {
    dispatch(logout())
      .unwrap()
      .then(() => {
        setLoading(false);
        appSession.removeItem();
        redirectToLoginAfterLogout();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <div className="flex flex-row px-4 py-2 gap-5 items-center">
      <Flex align="center" gap="2">
        <Preferences />
      </Flex>

      <div className="grow" />

      <Tooltip content="Toggle theme">
        <IconButton
          variant="ghost"
          size="1"
          color="gray"
          onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
        >
          {theme === "light" ? <SunIcon /> : <MoonIcon />}
        </IconButton>
      </Tooltip>

      <DropdownMenu.Root>
        <DropdownMenu.Trigger>
          <Button variant="ghost" color="gray" className="text-xs">
            <PersonIcon />
            <Skeleton loading={isLoading} className="min-w-20 h-4">
              {staffMe?.result.first_name} {staffMe?.result.last_name}
            </Skeleton>
          </Button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content>
          <DropdownMenu.Item asChild>
            <Link to={`/stores/${storeKey}/planogram-2d`}>
              <LayersIcon />
              <span>Planogram 2D</span>
            </Link>
          </DropdownMenu.Item>
          <DropdownMenu.Item disabled={loading} onClick={handleLogout}>
            <ExitIcon />
            Logout
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </div>
  );
}
